export default {

    state: {
        facilities: [],
        facility: [],
        facility_units: [],
        facility_admissions: [],
        facility_inspections: [],
        facility_signatures: [],
        facility_billings: [],
        facility_complaints: [],
        facility_incidents: [],
        stats: [],
        contracts: [],
        contract: null,
        contract_attachments: null,
        comments: [],
        staff: [],
        histories: [],
        files: [],
        facility_id: null,
        errors: {},
        url: '/api/hms/locations/facilities',
        form: {
            code: '',
            type: '',
            vendor_id: '',
            name: '',
            city: '',
            state_id: '',
            zip: '',
            contact: '',
            phone: '',
            email: '',
            start_hasa: null,
            start_ehp: null,
            mou_from: null,
            mou_to: null,
            ein: '',
            rate: '',
            total_units: '',
            medicine: true,
            handicap_access: true,
            smoke_free: true,
            elevator: true,
            notes: '',
        },
        other_form: {},
        staff_form: {},
        meta: {
            current_page: 1,
            per_page: 10,
            total: 0,
            from: '',
            to: '',
            sort: 'desc',
            order_by: 'Choose',
            sort_by: 'created_at',
            sort_desc: true,
            search: '',
            page_sizes: [10, 25, 50, 100],
        },
        units_meta: {
            current_page: 1,
            per_page: "10",
            total: 0,
            from: '',
            to: '',
            page_sizes: [10, 25, 50, 100],
        },
        admissions_meta: {
            current_page: 1,
            per_page: "10",
            total: 0,
            from: '',
            to: '',
            page_sizes: [10, 25, 50, 100],
        },
        inspections_meta: {
            current_page: 1,
            per_page: "10",
            total: 0,
            from: '',
            to: '',
            page_sizes: [10, 25, 50, 100],
        },
        signatures_meta: {
            current_page: 1,
            per_page: "10",
            total: 0,
            from: '',
            to: '',
            page_sizes: [10, 25, 50, 100],
        },
        billings_meta: {
            current_page: 1,
            per_page: "10",
            total: 0,
            from: '',
            to: '',
            page_sizes: [10, 25, 50, 100],
        },
        complaints_meta: {
            current_page: 1,
            per_page: "10",
            total: 0,
            from: '',
            to: '',
            page_sizes: [10, 25, 50, 100],
        },
        incidents_meta: {
            current_page: 1,
            per_page: "10",
            total: 0,
            from: '',
            to: '',
            page_sizes: [10, 25, 50, 100],
        },
        table: {
            fields: [
                {key: 'code', label: 'Code', sortable: true, tdClass: ''},
                {key: 'name', label: 'Name', sortable: true, tdClass: ''},
                {key: 'vendor', label: 'Vendor', tdClass: ''},
                {key: 'rate', label: 'Rate', sortable: true, tdClass: 'text-muted'},
                {key: 'total_units', label: 'Contract Units', sortable: true, tdClass: 'text-muted'},
                {key: 'actual_units', label: 'Actual Units', sortable: true, tdClass: 'text-muted'},
                {key: 'currently_occupied', label: 'Occupied', tdClass: 'text-muted'},
                {key: 'type', label: 'Type', sortable: true, tdClass: 'text-muted'},
                {key: 'status', label: 'Status', sortable: true, thClass: 'text-center', tdClass: 'text-center'},
                {key: 'actions', label: 'Actions', thClass: 'text-center', tdClass: 'text-center'},
            ]
        },
    },

    getters: {
        getFacilities: state => state.facilities,

        getFacility: state => state.facility,

        getFacilityStats: state => state.stats,

        getFacilityContracts: state => state.contracts,

        getFacilityContract: state => state.contract,

        getFacilityContractAttachments: state => state.contract_attachments,

        getFacilityComments: state => state.comments,

        getFacilityStaff: state => state.staff,

        getFacilityHistories: state => state.histories,

        getFacilityFiles: state => state.files,

        getFacilityForm: state => state.form,

        getFacilitiesMeta: state => state.meta,

        getFacilityUnitsMeta: state => state.units_meta,

        getFacilityAdmissionsMeta: state => state.admissions_meta,

        getFacilityInspctionsMeta: state => state.inspections_meta,

        getFacilitySignaturesMeta: state => state.signatures_meta,

        getFacilityBillingsMeta: state => state.billings_meta,

        getFacilityComplaintsMeta: state => state.complaints_meta,

        getFacilityIncidentsMeta: state => state.incidents_meta,

        getFacilityErrors: state => state.errors,

        getFacilityOtherForm: state => state.other_form,

        getFacilityStaffForm: state => state.staff_form,

        getFacilityTableFields: state => state.table.fields,
    },

    mutations: {
        setFacilities: (state, payload) => {
            state.facilities = payload;
        },

        setFacility: (state, payload) => {
            state.facility_id = payload.facility_id;
            state.facility = payload;
        },

        setFacilityUnits: (state, payload) => {
            state.facility_units = payload;
        },

        setFacilityAdmissions: (state, payload) => {
            state.facility_admissions = payload;
        },

        setFacilityInspections: (state, payload) => {
            state.facility_inspections = payload;
        },

        setFacilitySignatures: (state, payload) => {
            state.facility_signatures = payload;
        },

        setFacilityBillings: (state, payload) => {
            state.facility_billings = payload;
        },

        setFacilityComplaints: (state, payload) => {
            state.facility_complaints = payload;
        },

        setFacilityIncidents: (state, payload) => {
            state.facility_incidents = payload;
        },

        setFacilitiesMeta: (state, payload) => {
            state.meta = {...state.meta, ...payload};
        },

        setFacilityUnitsMeta: (state, payload) => {
            state.units_meta = {...state.units_meta, ...payload};
        },

        setFacilityAdmissionsMeta: (state, payload) => {
            state.admissions_meta = {...state.admissions_meta, ...payload};
        },

        setFacilityInspectionsMeta: (state, payload) => {
            state.inspections_meta = {...state.inspections_meta, ...payload};
        },

        setFacilitySignaturesMeta: (state, payload) => {
            state.signatures_meta = {...state.signatures_meta, ...payload};
        },

        setFacilityBillingssMeta: (state, payload) => {
            state.billings_meta = {...state.billings_meta, ...payload};
        },

        setFacilityComplaintsMeta: (state, payload) => {
            state.complaints_meta = {...state.complaints_meta, ...payload};
        },

        setFacilityIncidentsMeta: (state, payload) => {
            state.incidents_meta = {...state.incidents_meta, ...payload};
        },

        setFacilityErrors: (state, payload) => {
            state.errors = payload;
        },

        setFacilityStats: (state, payload) => {
            state.stats = payload;
        },

        setFacilityContracts: (state, payload) => {
            state.contracts = payload;
        },

        setFacilityContract: (state, payload) => {
            state.contract = payload;
        },

        setFacilityContractAttachments: (state, payload) => {
            state.contract_attachments = payload;
        },

        setFacilityComments: (state, payload) => {
            state.comments = payload;
        },

        setFacilityStaff: (state, payload) => {
            state.staff = payload;
        },

        setFacilityHistories: (state, payload) => {
            state.histories = payload;
        },

        setFacilityFiles: (state, payload) => {
            state.files = payload;
        },

        setFacilityForm: state => {
            state.form = {
                code: '',
                type: '',
                vendor_id: '',
                name: '',
                city: '',
                state_id: '',
                zip: '',
                contact: '',
                phone: '',
                email: '',
                start_hasa: null,
                start_ehp: null,
                mou_from: null,
                mou_to: null,
                ein: '',
                rate: '',
                total_units: '',
                medicine: true,
                handicap_access: true,
                smoke_free: true,
                elevator: true,
                notes: '',
            };

            state.errors = {};
        },

        resetFacilitiesMeta: state => {
            state.meta = {
                current_page: 1,
                per_page: 10,
                total: 0,
                from: '',
                to: '',
                sort: 'desc',
                order_by: 'Choose',
                sort_by: 'created_at',
                sort_desc: true,
                search: '',
                page_sizes: [10, 25, 50, 100],
            };
        },

        setFacilityOtherForm: state => {
            state.other_form = {
                status: state.facility.data.attributes.status,
                body: '',
            };

            state.errors = {};
        },

        setFacilityStaffForm: state => {
            state.staff_form = {
                facility_id: state.facility.facility_id,
                user_id: '',
                date: null,
                assigned_as: '',
            };

            state.errors = {};
        },
    },

    actions: {
        fetchFacilities: ({state, commit}) => {
            let parameters = {
                page: state.meta.current_page,
                per_page: state.meta.per_page,
                sort_by: state.meta.sort_by,
                sort: state.meta.sort,
                search: state.meta.search,
            };

            if (!parameters.search && parameters.search.length <= 3) {
                delete parameters.search;
            }

            return new Promise((resolve, reject) => {
                axios.get(state.url+'?state', {params: parameters})
                    .then(response => {
                        commit('setFacilities', response.data);

                        commit('setFacilitiesMeta', response.data.meta);

                        resolve(response.data);
                    })
                    .catch(error => {
                        commit('setFacilityErrors', error.response.data.errors);

                        reject();
                    });
            });
        },

        fetchFacility: ({state, commit}, facility_id) => {
            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + facility_id)
                    .then(response => {
                        commit('setFacility', response.data);
                        commit('setFacilityOtherForm', response.data);
                        commit('setFacilityStaffForm', response.data);

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        submitFacility: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.post(state.url, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        if (error.response.data.errors) {
                            commit('setFacilityErrors', error.response.data.errors);
                        }

                        reject(error);
                    });
            })
        },

        updateFacility: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.patch(state.url + '/' + state.facility_id, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        if (error.response.data.errors) {
                            commit('setFacilityErrors', error.response.data.errors);
                        }

                        reject(error);
                    });
            })
        },

        deleteFacility: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.delete(state.url + '/' + payload.facility_id)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            })
        },

        fetchEditFacility: ({state, commit}, facility_id) => {
            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + facility_id + '/edit')
                    .then(response => {
                        state.facility_id = response.data.id;

                        state.form = response.data;

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        submitFacilityStatus: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.patch(state.url + '/' + state.facility_id + '/status', payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        if (error.response.data.errors) {
                            commit('setFacilityErrors', error.response.data.errors);
                        }

                        reject(error);
                    });
            })
        },

        submitFacilityContract: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.post(state.url + '/' + state.facility_id + '/contracts', payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        if (error.response.data.errors) {
                            commit('setFacilityErrors', error.response.data.errors);
                        }

                        reject(error);
                    });
            })
        },

        submitFacilityComment: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.post(state.url + '/' + state.facility_id + '/comments', payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        if (error.response.data.errors) {
                            commit('setFacilityErrors', error.response.data.errors);
                        }

                        reject(error);
                    });
            })
        },

        submitFacilityStaff: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.post(state.url + '/' + state.facility.facility_id + '/staff', payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        if (error.response.data.errors) {
                            commit('setFacilityErrors', error.response.data.errors);
                        }

                        reject(error);
                    });
            })
        },

        unassignFacilityStaff: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.delete(state.url + '/' + state.facility.facility_id + '/staff/' + payload.staff_id)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject();
                    });
            })
        },

        fetchFacilityStats: ({state, commit}, facility_id) => {
            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + facility_id + '/stats')
                    .then(response => {
                        commit('setFacilityStats', response.data);

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        fetchFacilityContracts: ({state, commit}, facility_id) => {
            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + facility_id + '/contracts')
                    .then(response => {
                        commit('setFacilityContracts', response.data.data);

                        resolve(response.data.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        fetchFacilityComments: ({state, commit}, facility_id) => {
            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + facility_id + '/comments')
                    .then(response => {
                        commit('setFacilityComments', response.data.data);

                        resolve(response.data.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        fetchFacilityStaff: ({state, commit}, facility_id) => {
            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + facility_id + '/staff')
                    .then(response => {
                        commit('setFacilityStaff', response.data.data);

                        resolve(response.data.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        fetchFacilityHistories: ({state, commit}, facility_id) => {
            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + facility_id + '/histories')
                    .then(response => {
                        commit('setFacilityHistories', response.data.data);

                        resolve(response.data.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        fetchFacilityUnits: ({state, commit}, facility_id) => {
            let parameters = {
                page: state.units_meta.current_page,
                per_page: state.units_meta.per_page,
            };

            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + facility_id + '/units', {params: parameters})
                    .then(response => {
                        commit('setFacilityUnits', response.data);

                        commit('setFacilityUnitsMeta', response.data.meta);

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject();
                    });
            });
        },

        fetchFacilityAdmissions: ({state, commit}, facility_id) => {
            let parameters = {
                page: state.admissions_meta.current_page,
                per_page: state.admissions_meta.per_page,
            };

            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + facility_id + '/admissions', {params: parameters})
                    .then(response => {
                        commit('setFacilityAdmissions', response.data);

                        commit('setFacilityAdmissionsMeta', response.data.meta);

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject();
                    });
            });
        },

        fetchFacilityInspections: ({state, commit}, facility_id) => {
            let parameters = {
                page: state.inspections_meta.current_page,
                per_page: state.inspections_meta.per_page,
            };

            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + facility_id + '/inspections', {params: parameters})
                    .then(response => {
                        commit('setFacilityInspections', response.data);

                        commit('setFacilityInspectionsMeta', response.data.meta);

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject();
                    });
            });
        },

        fetchFacilitySignatures: ({state, commit}, facility_id) => {
            let parameters = {
                page: state.signatures_meta.current_page,
                per_page: state.signatures_meta.per_page,
            };

            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + facility_id + '/signatures', {params: parameters})
                    .then(response => {
                        commit('setFacilitySignatures', response.data);

                        commit('setFacilitySignaturesMeta', response.data.meta);

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject();
                    });
            });
        },

        fetchFacilityBillings: ({state, commit}, facility_id) => {
            let parameters = {
                page: state.billings_meta.current_page,
                per_page: state.billings_meta.per_page,
            };

            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + facility_id + '/billings', {params: parameters})
                    .then(response => {
                        commit('setFacilityBillings', response.data);

                        commit('setFacilityBillingsMeta', response.data.meta);

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject();
                    });
            });
        },

        fetchFacilityComplaints: ({state, commit}, facility_id) => {
            let parameters = {
                page: state.complaints_meta.current_page,
                per_page: state.complaints_meta.per_page,
            };

            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + facility_id + '/complaints', {params: parameters})
                    .then(response => {
                        commit('setFacilityComplaints', response.data);

                        commit('setFacilityComplaintsMeta', response.data.meta);

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject();
                    });
            });
        },

        fetchFacilityIncidents: ({state, commit}, facility_id) => {
            let parameters = {
                page: state.incidents_meta.current_page,
                per_page: state.incidents_meta.per_page,
            };

            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + facility_id + '/incidents', {params: parameters})
                    .then(response => {
                        commit('setFacilityIncidents', response.data);

                        commit('setFacilityIncidentsMeta', response.data.meta);

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject();
                    });
            });
        },

        fetchFacilityFiles: ({state, commit}, facility_id) => {
            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + facility_id + '/files')
                    .then(response => {
                        commit('setFacilityFiles', response.data.data);

                        resolve(response.data.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        fetchEditFacilityComment: ({state, commit}, comment_id) => {
            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + state.facility_id + '/comments/' + comment_id + '/edit')
                    .then(response => {
                        state.other_form = response.data;

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        fetchFacilityContract: ({state, commit}, contract_id) => {
            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + state.facility_id + '/contracts/' + contract_id)
                    .then(response => {
                        commit('setFacilityContract', response.data);

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        fetchFacilityContractAttachments: ({state, commit}, contract_id) => {
            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + state.facility_id + '/contracts/' + contract_id + '/attachments')
                    .then(response => {
                        commit('setFacilityContractAttachments', response.data.data);

                        resolve(response.data.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        fetchEditFacilityContract: ({state, commit}, contract_id) => {
            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + state.facility_id + '/contracts/' + contract_id + '/edit')
                    .then(response => {
                        state.other_form = response.data;

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        updateFacilityComment: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.patch(state.url + '/' + state.facility_id + '/comments/' + payload.id, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setFacilityErrors', error.response.data.errors);

                        reject();
                    });
            })
        },

        updateFacilityContract: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.patch(state.url + '/' + state.facility_id + '/contracts/' + payload.id, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setFacilityErrors', error.response.data.errors);

                        reject();
                    });
            })
        },

        deleteFacilityComment: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.delete(state.url + '/' + state.facility_id + '/comments/' + payload.comment_id)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            })
        },

        deleteFacilityContract: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.delete(state.url + '/' + state.facility_id + '/contracts/' + payload.contract_id)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            })
        },
    }

}
